import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
// import { MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SettingsService } from '../../services/setting-service/setting.service';
import { DoctorService } from './../../services/doctor-service/doctor.service';
import { EditDoctor } from './edit-doctor/edit-doctor';
import { Chart, registerables } from 'chart.js';
import { ufOptions, especialidadesEAreasDeAtuacao } from '../../models/index';
import { ReportService } from '../../services/report-service/report.service';

Chart.register(...registerables);

@Component({
    selector: 'app-doctor',
    standalone: false,
    templateUrl: './doctor.html',
    styleUrl: './doctor.scss'
})
export class Doctor implements OnInit {

    dataSourceSearch: any = [];
    params: any = {};
    // Propriedades para os filtros
    selectedMedicosUfs = new FormControl();
    selectedMedicosStatus = new FormControl();
    selectedEspecialidades = new FormControl();
    selectedResgates = new FormControl();
    
    // Opções para os selects
    ufOptions: any = ufOptions;
    medicosStatusOptions = [
        { value: true, description: 'Liberado' },
        { value: false, description: 'Bloqueado' }
    ];
    medicosStatusResgates = [
        { value: 'com_resgate', description: 'Com resgate' },
        { value: 'sem_resgate', description: 'Sem resgate' }
    ];
    especialidadeOptions: any = especialidadesEAreasDeAtuacao;
    
    // Controle de expansão dos filtros
    filtersExpanded = true;

    // Estatísticas filtradas
    filteredStats = {
        totalMedicos: 1250,
        medicosAtivos: 980,
        medicosInativos: 270,
        especialidadesPrincipais: 15
    };

    // Dados da tabela
    displayedColumns: string[] = ['uf', 'crm', 'nome', 'especialidade', 'status', 'pedido', 'acoes'];
    dataSource: any = [];
    filteredDataSource: any = [];
    loading: boolean = false;
    
    // Paginação
    pageSize = 25;
    pageIndex = 0;
    pageSizeOptions: number[] = [25, 50, 100];
    
    // Dados paginados
    paginatedDataSource: any[] = [];

    constructor(private doctorService: DoctorService,
        public settingsService: SettingsService,
        private dialog: MatDialog,
        private reportService: ReportService
    ) {
        this.settingsService.title = 'Gestão de Médicos';
    }

    async ngOnInit() {        
        await this.getDoctors();
    }

    // Método para formatar números
    formatNumber(value: number): string {
        return value.toLocaleString('pt-BR');
    }

    async getDoctors() {
        this.loading = true;
        this.applyFilters();
        
        this.dataSource = await this.doctorService.getDoctors(this.params);
        console.log('getDoctors - dataSource: ', JSON.stringify(this.dataSource));
        
        // Aplicar filtros nos dados recebidos
        this.filteredDataSource = this.dataSource;
        this.updateStatsFromFilteredData();
        
        this.loading = false;

        // setTimeout(() => {
        //     this.createMedicosUfChart();
        //     this.createMedicosStatusChart();
        //     this.createMedicosEspecialidadeChart();
        //     this.createMedicosEvolucaoChart();
        // }, 100);
    }

    // Verificar se há filtros ativos
    hasActiveFilters(): boolean {
        return !!(
            (this.selectedMedicosUfs.value && this.selectedMedicosUfs.value.length > 0) ||
            (this.selectedMedicosStatus.value && this.selectedMedicosStatus.value.length > 0) ||
            (this.selectedEspecialidades.value && this.selectedEspecialidades.value.length > 0) ||
            (this.selectedResgates.value && this.selectedResgates.value.length > 0)
        );
    }

    // Toggle para expandir/recolher filtros
    toggleFilters() {
        this.filtersExpanded = !this.filtersExpanded;
    }

    // Calcular taxa de ativação
    getAtivacaoRate(): number {
        const total = this.filteredStats.medicosAtivos + this.filteredStats.medicosInativos;
        if (total === 0) return 0;
        return Math.round((this.filteredStats.medicosAtivos / total) * 100);
    }

    // Aplicar filtros aos dados da tabela
    applyFilters() {
        this.params = {
            ufs: this.selectedMedicosUfs.value ? this.selectedMedicosUfs.value.map((uf: string) => uf.split(' - ')[0]) : [],
            status: this.selectedMedicosStatus.value || [],
            especialidades: this.selectedEspecialidades.value || [],
            resgates: this.selectedResgates.value || []
        };
    }

    // Atualizar estatísticas baseado nos dados filtrados
    updateStatsFromFilteredData() {
        const totalMedicos = this.filteredDataSource.length;
        const medicosAtivos = this.filteredDataSource.filter((d: any) => d.status === true).length;
        const medicosInativos = this.filteredDataSource.filter((d: any) => d.status === false).length;
        
        this.filteredStats = {
            totalMedicos: totalMedicos,
            medicosAtivos: medicosAtivos,
            medicosInativos: medicosInativos,
            especialidadesPrincipais: this.getUniqueEspecialidadesCount()
        };
        
        // Atualizar dados paginados
        this.updatePaginatedData();
    }

    // Atualizar dados paginados
    updatePaginatedData() {
        const startIndex = this.pageIndex * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.paginatedDataSource = this.filteredDataSource.slice(startIndex, endIndex);
    }

    // Evento de mudança de página
    onPageChange(event: any) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.updatePaginatedData();
    }

    // Obter total de páginas
    getTotalPages(): number {
        return Math.ceil(this.filteredDataSource.length / this.pageSize);
    }

    // Obter número total de itens
    getTotalItems(): number {
        return this.filteredDataSource.length;
    }

    // Obter contagem de especialidades únicas
    getUniqueEspecialidadesCount(): number {
        const especialidades = this.filteredDataSource
            .filter((d: any) => d.especialidade)
            .map((d: any) => d.especialidade);
        return [...new Set(especialidades)].length;
    }

    clearFilters() {
        this.selectedMedicosUfs.setValue([]);
        this.selectedMedicosStatus.setValue([]);
        this.selectedEspecialidades.setValue([]);
        this.selectedResgates.setValue([]);

        this.params = {
            ufs: [],
            status: [],
            especialidades: [],
            resgates: []
        };
        
        this.getDoctors();        
    }

    // Método para ver detalhes do médico (modal view-only)
    verDetalhes(doctor: any): void {
        const dialogRef = this.dialog.open(EditDoctor, {
            width: '80vw',
            height: '80vh',
            enterAnimationDuration: '0ms',
            exitAnimationDuration: '0ms',
            data: { 
                doctor: doctor,
                readOnly: true,
                editableFields: ['status']
            },
        });

        dialogRef.afterClosed().subscribe(updatedDoctor => {
            if (updatedDoctor) {
                const index = this.dataSource.findIndex((m: any) => m.crm === updatedDoctor.crm);
                if (index !== -1) {
                    this.dataSource[index] = updatedDoctor;
                    this.dataSource = [...this.dataSource];
                    // Reaplicar filtros após edição
                    this.applyFilters();
                }
            }
        });
    }

    // Método para editar médico (passando o objeto médico completo)
    editar(doctor: any): void {
        const dialogRef = this.dialog.open(EditDoctor, {
            width: '30vw',
            height: '25vh',
            enterAnimationDuration: '0ms',
            exitAnimationDuration: '0ms',
            data: { doctor: doctor },
        });

        dialogRef.afterClosed().subscribe(updatedDoctor => {
            if (updatedDoctor) {
                const index = this.dataSource.findIndex((m: any) => m.crm === updatedDoctor.crm);
                if (index !== -1) {
                    this.dataSource[index] = updatedDoctor;
                    this.dataSource = [...this.dataSource];
                    // Reaplicar filtros após edição
                    this.applyFilters();
                }
            }
        });
    }

    initializeStats() {
        // Valores iniciais das estatísticas
        this.filteredStats = {
            totalMedicos: 1250,
            medicosAtivos: 980,
            medicosInativos: 270,
            especialidadesPrincipais: 15
        };
    }

    updateFilteredStats() {
        // Obter valores dos filtros
        const medicosUfsSelecionadas = this.selectedMedicosUfs.value || [];
        const medicosStatusSelecionados = this.selectedMedicosStatus.value || [];
        const especialidadesSelecionadas = this.selectedEspecialidades.value || [];
        
        // Simular cálculo das estatísticas com base nos filtros
        let baseTotal = 1250;
        let baseAtivos = 980;
        let baseInativos = 270;
        let baseEspecialidades = 15;
        
        // Ajustar baseado nos filtros selecionados
        if (medicosStatusSelecionados.length > 0) {
            const ativos = medicosStatusSelecionados.includes('ativo') ? 0.8 : 0.2;
            baseAtivos = Math.floor(baseTotal * ativos);
            baseInativos = Math.floor(baseTotal * (1 - ativos));
        }
        
        if (medicosUfsSelecionadas.length > 0) {
            const fatorUf = medicosUfsSelecionadas.length / this.ufOptions.length;
            baseTotal = Math.floor(baseTotal * (0.7 + fatorUf * 0.5));
            baseAtivos = Math.floor(baseAtivos * (0.7 + fatorUf * 0.5));
            baseInativos = Math.floor(baseInativos * (0.7 + fatorUf * 0.5));
        }
        
        if (especialidadesSelecionadas.length > 0) {
            const fatorEspecialidade = especialidadesSelecionadas.length / this.especialidadeOptions.length;
            baseEspecialidades = Math.floor(baseEspecialidades * (0.6 + fatorEspecialidade * 0.6));
        }
        
        // Atualizar estatísticas filtradas
        this.filteredStats = {
            totalMedicos: baseTotal,
            medicosAtivos: baseAtivos,
            medicosInativos: baseInativos,
            especialidadesPrincipais: baseEspecialidades
        };
        
        console.log('Estatísticas atualizadas:', this.filteredStats);
    }

    updateCharts() {
        // Atualizar gráficos com os dados filtrados
        setTimeout(() => {
            this.createMedicosUfChart();
            this.createMedicosStatusChart();
            this.createMedicosEspecialidadeChart();
            this.createMedicosEvolucaoChart();
        }, 100);
    }

    // Métodos para criar gráficos
    createMedicosUfChart() {
        const ctx = document.getElementById('medicosUfChart') as HTMLCanvasElement;
        if (!ctx) return;

        const ufData = [
            { uf: 'SP', medicos: 280 },
            { uf: 'RJ', medicos: 195 },
            { uf: 'MG', medicos: 175 },
            { uf: 'BA', medicos: 120 },
            { uf: 'RS', medicos: 110 },
            { uf: 'PR', medicos: 95 },
            { uf: 'PE', medicos: 85 },
            { uf: 'CE', medicos: 75 },
            { uf: 'GO', medicos: 65 }
        ];

        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ufData.map(item => item.uf),
                datasets: [{
                    label: 'Médicos',
                    data: ufData.map(item => item.medicos),
                    backgroundColor: '#B7286C',
                    borderColor: '#B7286C',
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }

    createMedicosStatusChart() {
        const ctx = document.getElementById('medicosStatusChart') as HTMLCanvasElement;
        if (!ctx) return;

        new Chart(ctx, {
            type: 'pie',
            data: {
                labels: ['Ativos', 'Inativos'],
                datasets: [{
                    data: [this.filteredStats.medicosAtivos, this.filteredStats.medicosInativos],
                    backgroundColor: ['#4CAF50', '#F44336'],
                    borderWidth: 2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        });
    }

    createMedicosEspecialidadeChart() {
        const ctx = document.getElementById('medicosEspecialidadeChart') as HTMLCanvasElement;
        if (!ctx) return;

        const especialidadeData = [
            { especialidade: 'Clínica Geral', count: 180 },
            { especialidade: 'Pediatria', count: 145 },
            { especialidade: 'Cardiologia', count: 120 },
            { especialidade: 'Ginecologia', count: 110 },
            { especialidade: 'Ortopedia', count: 95 }
        ];

        new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: especialidadeData.map(item => item.especialidade),
                datasets: [{
                    data: especialidadeData.map(item => item.count),
                    backgroundColor: [
                        '#B7286C', '#9C27B0', '#2196F3', '#4CAF50', '#FF9800'
                    ],
                    borderWidth: 2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        });
    }

    createMedicosEvolucaoChart() {
        const ctx = document.getElementById('medicosEvolucaoChart') as HTMLCanvasElement;
        if (!ctx) return;

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
                datasets: [{
                    label: 'Médicos Ativos',
                    data: [850, 880, 910, 920, 950, 980],
                    borderColor: '#B7286C',
                    backgroundColor: 'rgba(183, 40, 108, 0.1)',
                    tension: 0.4,
                    fill: true
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }

    search(value: string): any[] {
        this.loading = true;

        const filterValue = value.toLowerCase();

        this.dataSourceSearch = this.dataSource.filter((option: any) =>
            option.crm.toString().includes(filterValue) ||
            option.nome.toLowerCase().includes(filterValue) ||
            option.especialidades && option.especialidades.toLowerCase().includes(filterValue)
        );
        this.loading = false;

        return this.dataSourceSearch;
    }

    downloadReport() {
        this.applyFilters();
        this.loading = true;
        this.reportService.downloadDoctorReport(this.params);
        console.log('Report: iniciado');
        this.loading = false;
    }

}
